import { render, staticRenderFns } from "./DetailInvoice.vue?vue&type=template&id=50630c4b&scoped=true&"
import script from "./DetailInvoice.vue?vue&type=script&lang=js&"
export * from "./DetailInvoice.vue?vue&type=script&lang=js&"
import style0 from "./DetailInvoice.vue?vue&type=style&index=0&id=50630c4b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50630c4b",
  null
  
)

export default component.exports